export default __webpack_public_path__ + "static/media/app_logo.09ad7689.svg";